import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class ExcursionService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getExcursions(eventId): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/get",{
    params : {
     eventId:eventId
    }
   }).map(response => response.json().excursions);
  }

  findExcursion(excursionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/find",{
    params : {
     id:excursionId
    }
   }).map(response => response.json().excursion);
  }

  saveExcursion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/save", params, this.options).map(response => response.json());
  }

  deleteExcursion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/delete", params, this.options).map(response => response.json());
  }

  getExcursionQuestions(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/get_excursion_questions",{
    params : {
     excursionId:params.excursionId,
     parentOptionId:params.optionId
    }
   }).map(response => response.json().excursionQuestions);
  }

  getExcursionQuestionsWithOptions(params): Observable<any> {
   return this.http.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/get_excursion_questions_with_options",{
    params : {
     excursionId:params.excursionId,
    }
   }).map(response => response.json().excursionQuestions);
  }

  findExcursionQuestion(excursionQuestionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/find_excursion_question",{
    params : {
     id:excursionQuestionId
    }
   }).map(response => response.json().excursionQuestion);
  }

  saveExcursionQuestion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/"+(params.id?'edit_excursion_question':'add_excursion_question'), params, this.options).map(response => response.json());
  }

  deleteExcursionQuestion(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/delete_excursion_question", params, this.options).map(response => response.json());
  }

  getExcursionQuestionOptions(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/get_excursion_question_options",{
    params : {
     questionId:params.excursionQuestionId
    }
   }).map(response => response.json().excursionQuestionOptions);
  }

  findExcursionQuestionOption(excursionQuestionOptionId): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/find_excursion_question_option",{
    params : {
     id:excursionQuestionOptionId
    }
   }).map(response => response.json().excursionQuestionOption);
  }

  saveExcursionQuestionOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/"+(params.id?'edit_excursion_question_option':'add_excursion_question_option'), params, this.options).map(response => response.json());
  }

  deleteExcursionQuestionOption(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/excursion/delete_excursion_question_option", params, this.options).map(response => response.json());
  }

  changeActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/trip/admin-change-excursion", params, this.options).map(response => response.json());
  }

  changeActivityMail(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/trip/admin-change-excursion-mail", params, this.options).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/excursion.service.ts